// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2cXIC","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2MkUs","obliqueLine":"membershipbadge_obliqueLine__iNvmI"};